import { CompleteKundali, Language, PlanetName, ZodiacSign } from '../../types/kundali';
import { AshtakootaSynastryResult, AshtakootaComponentResult, ManglikDoshaDetail } from '../../types/v518';
import { ZODIAC_LORDS } from '../vedicEngine';
import { formatOrdinal } from '../dateUtils';
import { evaluateManglikDosha } from '../yogaDoshaEngine';

/* ==========================================================================
   VEDANG JYOTISHAM V5.18 — ASHTAKOOTA SYNASTRY & MILAN ENGINE (V518-04)
   Full 36-Guna Evaluation with Precise Dosha Detection & Classical Cancellations
   ========================================================================== */

export const NAKSHATRA_NAMES = [
  'Ashwini', 'Bharani', 'Krittika', 'Rohini', 'Mrigashira', 'Ardra',
  'Punarvasu', 'Pushya', 'Ashlesha', 'Magha', 'Purva Phalguni', 'Uttara Phalguni',
  'Hasta', 'Chitra', 'Swati', 'Vishakha', 'Anuradha', 'Jyeshtha',
  'Mula', 'Purva Ashadha', 'Uttara Ashadha', 'Shravana', 'Dhanishta', 'Shatabhisha',
  'Purva Bhadrapada', 'Uttara Bhadrapada', 'Revati'
];

export const YONI_NAMES = [
  'Horse', 'Elephant', 'Sheep', 'Serpent', 'Serpent', 'Dog',
  'Cat', 'Sheep', 'Cat', 'Rat', 'Rat', 'Cow',
  'Buffalo', 'Tiger', 'Buffalo', 'Tiger', 'Deer', 'Deer',
  'Dog', 'Monkey', 'Mongoose', 'Monkey', 'Lion', 'Horse',
  'Lion', 'Cow', 'Elephant'
];

export const GANA_NAMES = [
  'Deva', 'Manushya', 'Rakshasa', 'Manushya', 'Deva', 'Manushya',
  'Deva', 'Deva', 'Rakshasa', 'Rakshasa', 'Manushya', 'Manushya',
  'Deva', 'Rakshasa', 'Deva', 'Rakshasa', 'Deva', 'Rakshasa',
  'Rakshasa', 'Manushya', 'Manushya', 'Deva', 'Rakshasa', 'Rakshasa',
  'Manushya', 'Manushya', 'Deva'
];

export const NADI_NAMES = [
  'Aadi (Vata)', 'Madhya (Pitta)', 'Antya (Kapha)', 'Antya (Kapha)', 'Madhya (Pitta)', 'Aadi (Vata)',
  'Aadi (Vata)', 'Madhya (Pitta)', 'Antya (Kapha)', 'Antya (Kapha)', 'Madhya (Pitta)', 'Aadi (Vata)',
  'Aadi (Vata)', 'Madhya (Pitta)', 'Antya (Kapha)', 'Antya (Kapha)', 'Madhya (Pitta)', 'Aadi (Vata)',
  'Aadi (Vata)', 'Madhya (Pitta)', 'Antya (Kapha)', 'Antya (Kapha)', 'Madhya (Pitta)', 'Aadi (Vata)',
  'Aadi (Vata)', 'Madhya (Pitta)', 'Antya (Kapha)'
];

export const YONI_ANIMALS = [
  'Horse', 'Elephant', 'Sheep', 'Serpent', 'Dog', 'Cat', 'Rat',
  'Cow', 'Buffalo', 'Tiger', 'Deer', 'Monkey', 'Mongoose', 'Lion'
];

export const VAIRA_YONI_PAIRS: [string, string][] = [
  ['Cow', 'Tiger'],
  ['Elephant', 'Lion'],
  ['Horse', 'Buffalo'],
  ['Dog', 'Deer'],
  ['Serpent', 'Mongoose'],
  ['Monkey', 'Sheep'],
  ['Cat', 'Rat']
];

export const YONI_COMPATIBILITY_MATRIX: number[][] = [
  // 0 Horse, 1 Elephant, 2 Sheep, 3 Serpent, 4 Dog, 5 Cat, 6 Rat, 7 Cow, 8 Buffalo, 9 Tiger, 10 Deer, 11 Monkey, 12 Mongoose, 13 Lion
  /* 0 Horse */    [4, 2, 2, 2, 2, 2, 2, 2, 0, 1, 3, 2, 2, 1],
  /* 1 Elephant */ [2, 4, 3, 3, 2, 2, 2, 3, 3, 1, 2, 3, 2, 0],
  /* 2 Sheep */    [2, 3, 4, 2, 1, 2, 1, 3, 3, 1, 2, 0, 2, 1],
  /* 3 Serpent */  [2, 3, 2, 4, 2, 1, 1, 1, 1, 1, 2, 2, 0, 2],
  /* 4 Dog */      [2, 2, 1, 2, 4, 2, 1, 1, 2, 1, 0, 2, 1, 1],
  /* 5 Cat */      [2, 2, 2, 1, 2, 4, 0, 2, 2, 1, 3, 2, 1, 1],
  /* 6 Rat */      [2, 2, 1, 1, 1, 0, 4, 2, 2, 1, 2, 2, 2, 1],
  /* 7 Cow */      [2, 3, 3, 1, 1, 2, 2, 4, 3, 0, 3, 2, 2, 1],
  /* 8 Buffalo */  [0, 3, 3, 1, 2, 2, 2, 3, 4, 1, 2, 2, 2, 1],
  /* 9 Tiger */    [1, 1, 1, 1, 1, 1, 1, 0, 1, 4, 1, 1, 1, 1],
  /* 10 Deer */    [3, 2, 2, 2, 0, 3, 2, 3, 2, 1, 4, 2, 2, 1],
  /* 11 Monkey */  [2, 3, 0, 2, 2, 2, 2, 2, 2, 1, 2, 4, 2, 1],
  /* 12 Mongoose */[2, 2, 2, 0, 1, 1, 2, 2, 2, 1, 2, 2, 4, 2],
  /* 13 Lion */    [1, 0, 1, 2, 1, 1, 1, 1, 1, 1, 1, 1, 2, 4]
];

export function getYoniScore(yoniA: string, yoniB: string): number {
  if (yoniA === yoniB) return 4;
  const isVaira = VAIRA_YONI_PAIRS.some(
    ([a, b]) => (yoniA === a && yoniB === b) || (yoniA === b && yoniB === a)
  );
  if (isVaira) return 0;
  const idxA = YONI_ANIMALS.indexOf(yoniA);
  const idxB = YONI_ANIMALS.indexOf(yoniB);
  if (idxA >= 0 && idxB >= 0 && YONI_COMPATIBILITY_MATRIX[idxA]) {
    return YONI_COMPATIBILITY_MATRIX[idxA][idxB] ?? 2;
  }
  return 2;
}

export function getVarnaBySign(signIndex: number): { name: string; nameHi: string; rank: number } {
  const s = ((signIndex % 12) + 12) % 12;
  if ([3, 7, 11].includes(s)) return { name: 'Brahmin', nameHi: 'ब्राह्मण', rank: 4 };
  if ([0, 4, 8].includes(s)) return { name: 'Kshatriya', nameHi: 'क्षत्रिय', rank: 3 };
  if ([1, 5, 9].includes(s)) return { name: 'Vaishya', nameHi: 'वैश्य', rank: 2 };
  return { name: 'Shudra', nameHi: 'शूद्र', rank: 1 };
}

export type VashyaCategory = 'Chatushpada' | 'Dwipada' | 'Jalachara' | 'Keeta' | 'Vanachara';

export function getVashyaCategory(
  signIndex: number,
  degInSign?: number
): { name: VashyaCategory; labelEn: string; labelHi: string } {
  const s = ((signIndex % 12) + 12) % 12;
  const deg = degInSign ?? 15;
  if (s === 0 || s === 1) { // Aries, Taurus
    return { name: 'Chatushpada', labelEn: 'Chatushpada (Quadruped)', labelHi: 'चतुष्पद' };
  }
  if (s === 2 || s === 5 || s === 6 || s === 10) { // Gemini, Virgo, Libra, Aquarius
    return { name: 'Dwipada', labelEn: 'Dwipada / Manava (Human)', labelHi: 'द्विपद (नर)' };
  }
  if (s === 3 || s === 11) { // Cancer, Pisces
    return { name: 'Jalachara', labelEn: 'Jalachara (Water Dweller)', labelHi: 'जलचर' };
  }
  if (s === 4) { // Leo
    return { name: 'Vanachara', labelEn: 'Vanachara (Wild Beast)', labelHi: 'वनचर (सिंह)' };
  }
  if (s === 7) { // Scorpio
    return { name: 'Keeta', labelEn: 'Keeta (Insect)', labelHi: 'कीट' };
  }
  if (s === 8) { // Sagittarius: 0-15° Human, 15-30° Quadruped
    return deg < 15
      ? { name: 'Dwipada', labelEn: 'Dwipada / Manava (Human)', labelHi: 'द्विपद (नर)' }
      : { name: 'Chatushpada', labelEn: 'Chatushpada (Quadruped)', labelHi: 'चतुष्पद' };
  }
  if (s === 9) { // Capricorn: 0-15° Quadruped, 15-30° Jalachara
    return deg < 15
      ? { name: 'Chatushpada', labelEn: 'Chatushpada (Quadruped)', labelHi: 'चतुष्पद' }
      : { name: 'Jalachara', labelEn: 'Jalachara (Water Dweller)', labelHi: 'जलचर' };
  }
  return { name: 'Dwipada', labelEn: 'Dwipada / Manava (Human)', labelHi: 'द्विपद (नर)' };
}

export function getVashyaScore(catBoy: VashyaCategory, catGirl: VashyaCategory): number {
  if (catBoy === catGirl) return 2;
  if (catBoy === 'Dwipada') {
    if (catGirl === 'Chatushpada') return 2;
    if (catGirl === 'Jalachara' || catGirl === 'Keeta') return 1;
    return 0;
  }
  if (catBoy === 'Chatushpada') {
    if (catGirl === 'Dwipada' || catGirl === 'Jalachara' || catGirl === 'Keeta') return 1;
    return 0;
  }
  if (catBoy === 'Jalachara') {
    if (catGirl === 'Dwipada' || catGirl === 'Chatushpada' || catGirl === 'Keeta') return 1;
    return 0;
  }
  if (catBoy === 'Keeta') {
    if (catGirl === 'Dwipada') return 0.5;
    if (catGirl === 'Chatushpada' || catGirl === 'Jalachara') return 1;
    return 0;
  }
  if (catBoy === 'Vanachara') {
    return 0;
  }
  return 1;
}

export const NATURAL_FRIENDS: Record<string, string[]> = {
  Sun: ['Moon', 'Mars', 'Jupiter'],
  Moon: ['Sun', 'Mercury'],
  Mars: ['Sun', 'Moon', 'Jupiter'],
  Mercury: ['Sun', 'Venus'],
  Jupiter: ['Sun', 'Moon', 'Mars'],
  Venus: ['Mercury', 'Saturn'],
  Saturn: ['Mercury', 'Venus']
};

export const NATURAL_ENEMIES: Record<string, string[]> = {
  Sun: ['Venus', 'Saturn'],
  Moon: [],
  Mars: ['Mercury'],
  Mercury: ['Moon'],
  Jupiter: ['Mercury', 'Venus'],
  Venus: ['Sun', 'Moon'],
  Saturn: ['Sun', 'Moon', 'Mars']
};

export function getGrahaMaitriScore(lordA: string, lordB: string): number {
  if (lordA === lordB) return 5;
  const isAFriendOfB = NATURAL_FRIENDS[lordA]?.includes(lordB);
  const isBFriendOfA = NATURAL_FRIENDS[lordB]?.includes(lordA);
  const isAEnemyOfB = NATURAL_ENEMIES[lordA]?.includes(lordB);
  const isBEnemyOfA = NATURAL_ENEMIES[lordB]?.includes(lordA);

  if (isAFriendOfB && isBFriendOfA) return 5;
  if ((isAFriendOfB && !isBEnemyOfA) || (isBFriendOfA && !isAEnemyOfB)) return 4;
  if (!isAEnemyOfB && !isBEnemyOfA) return 3;
  if (isAEnemyOfB && isBEnemyOfA) return 0;
  return 1;
}

export function calculateDetailedManglik(kundali: CompleteKundali, lang: Language = 'en'): ManglikDoshaDetail {
  const isHi = lang === 'hi';
  const canonical = evaluateManglikDosha(kundali);

  const cancellations: { ruleEn: string; ruleHi: string; isApplicable: boolean }[] = canonical.cancellations.map(c => ({
    ruleEn: c,
    ruleHi: c,
    isApplicable: true
  }));

  return {
    isManglik: canonical.isManglik,
    marsPlacementFromLagna: canonical.marsPlacementFromLagna ?? 1,
    marsPlacementFromMoon: canonical.marsPlacementFromMoon ?? 1,
    severityPercent: canonical.severityPercent,
    cancellations,
    isEffectivelyMitigated: canonical.isEffectivelyMitigated ?? false,
    verdictEn: canonical.verdictEn || (!canonical.isManglik 
      ? 'No Manglik influence detected.' 
      : canonical.isEffectivelyMitigated 
        ? 'Manglik presence is effectively neutralized by classical astrological mitigating factors.' 
        : 'Active Manglik placement; balanced matching or remedial awareness recommended.'),
    verdictHi: canonical.verdictHi || (!canonical.isManglik 
      ? 'कोई मांगलिक प्रभाव उपस्थित नहीं है।' 
      : canonical.isEffectivelyMitigated 
        ? 'शास्त्रीय परिहार नियमों के कारण मांगलिक प्रभाव शांत एवं निष्प्रभावी है।' 
        : 'सक्रिय मांगलिक स्थिति; उपयुक्त मिलान या शांतिकर्म श्रेयस्कर है।')
  };
}

export function calculateAshtakootaSynastry(
  partnerA: CompleteKundali,
  partnerB: CompleteKundali,
  partnerAName: string = 'Partner A',
  partnerBName: string = 'Partner B',
  lang: Language = 'en'
): AshtakootaSynastryResult {
  const isHi = lang === 'hi';

  const moonA = partnerA.planets.find(p => p.name === 'Moon') || partnerA.planets[0];
  const moonB = partnerB.planets.find(p => p.name === 'Moon') || partnerB.planets[0];

  const signAIdx = moonA.signIndex;
  const signBIdx = moonB.signIndex;
  const nakAIdx = moonA.nakshatraIndex % 27;
  const nakBIdx = moonB.nakshatraIndex % 27;

  const signA = moonA.sign;
  const signB = moonB.sign;
  const lordA = (ZODIAC_LORDS[signA] as string) || 'Mars';
  const lordB = (ZODIAC_LORDS[signB] as string) || 'Venus';

  const components: AshtakootaComponentResult[] = [];

  // 1. Varna (1 pt)
  const varnaA = getVarnaBySign(signAIdx);
  const varnaB = getVarnaBySign(signBIdx);
  const varnaPts = varnaA.rank >= varnaB.rank ? 1 : 0;
  components.push({
    gunaName: 'Varna',
    gunaNameHi: 'वर्ण कूट',
    maxPoints: 1,
    obtainedPoints: varnaPts,
    partnerAValue: varnaA.name,
    partnerBValue: varnaB.name,
    status: varnaPts === 1 ? 'EXCELLENT' : 'AVERAGE',
    descriptionEn: 'Measures spiritual refinement, intellectual harmony, and mutual respect.',
    descriptionHi: 'आध्यात्मिक समन्वय, बौद्धिक तालमेल और परस्पर सम्मान का आकलन।',
    classicalRuleReference: 'Brihat Parashara Hora Shastra (Ch. 57, v. 4–5)',
    isDoshaPresent: false
  });

  // 2. Vashya (2 pts)
  const degA = (moonA.longitude !== undefined) ? (moonA.longitude % 30) : 15;
  const degB = (moonB.longitude !== undefined) ? (moonB.longitude % 30) : 15;
  const vashyaA = getVashyaCategory(signAIdx, degA);
  const vashyaB = getVashyaCategory(signBIdx, degB);
  const vashyaPts = getVashyaScore(vashyaA.name, vashyaB.name);

  components.push({
    gunaName: 'Vashya',
    gunaNameHi: 'वश्य कूट',
    maxPoints: 2,
    obtainedPoints: vashyaPts,
    partnerAValue: vashyaA.labelEn,
    partnerBValue: vashyaB.labelEn,
    status: vashyaPts === 2 ? 'EXCELLENT' : vashyaPts >= 1 ? 'GOOD' : 'CONCERN',
    descriptionEn: 'Measures emotional attraction, magnetic balance, and marital devotion.',
    descriptionHi: 'भावनात्मक आकर्षण, आपसी सामंजस्य एवं वैवाहिक समर्पण का माप।',
    classicalRuleReference: 'Brihat Parashara Hora Shastra (Ch. 57, v. 6–9) & Muhurta Chintamani',
    isDoshaPresent: false
  });

  // 3. Tara (3 pts)
  const count1 = ((nakBIdx - nakAIdx + 27) % 27) + 1;
  const taraDist1 = (count1 % 9 === 0 ? 9 : count1 % 9) - 1; // 0 to 8

  const count2 = ((nakAIdx - nakBIdx + 27) % 27) + 1;
  const taraDist2 = (count2 % 9 === 0 ? 9 : count2 % 9) - 1; // 0 to 8

  const isAuspiciousTara = (idx: number) => [1, 3, 5, 7, 8].includes(idx);
  const score1 = isAuspiciousTara(taraDist1) ? 1.5 : (taraDist1 === 0 ? (nakAIdx === nakBIdx ? 1.5 : 0.5) : 0);
  const score2 = isAuspiciousTara(taraDist2) ? 1.5 : (taraDist2 === 0 ? (nakAIdx === nakBIdx ? 1.5 : 0.5) : 0);
  const taraPts = Math.min(3, Number((score1 + score2).toFixed(1)));
  const TARA_LABELS = ['Janma', 'Sampat', 'Vipat', 'Kshema', 'Pratyari', 'Sadhaka', 'Naidhana', 'Mitra', 'Param Mitra'];

  components.push({
    gunaName: 'Tara',
    gunaNameHi: 'तारा कूट',
    maxPoints: 3,
    obtainedPoints: taraPts,
    partnerAValue: TARA_LABELS[taraDist1],
    partnerBValue: TARA_LABELS[taraDist2],
    status: taraPts >= 2.5 ? 'EXCELLENT' : taraPts >= 1.5 ? 'GOOD' : 'AVERAGE',
    descriptionEn: 'Evaluates destiny alignment, health longevity, and prosperity support.',
    descriptionHi: 'भाग्य सहयोग, स्वास्थ्य दीर्घायु एवं समृद्धि का संकेतक।',
    classicalRuleReference: 'Parashara Jyotish (Tara Bala, BPHS Ch. 57)',
    isDoshaPresent: false
  });

  // 4. Yoni (4 pts)
  const yoniA = YONI_NAMES[nakAIdx];
  const yoniB = YONI_NAMES[nakBIdx];
  const yoniPts = getYoniScore(yoniA, yoniB);
  const isVaira = VAIRA_YONI_PAIRS.some(
    ([a, b]) => (yoniA === a && yoniB === b) || (yoniA === b && yoniB === a)
  );

  components.push({
    gunaName: 'Yoni',
    gunaNameHi: 'योनि कूट',
    maxPoints: 4,
    obtainedPoints: yoniPts,
    partnerAValue: yoniA,
    partnerBValue: yoniB,
    status: yoniPts >= 3 ? 'EXCELLENT' : yoniPts >= 2 ? 'GOOD' : 'CONCERN',
    descriptionEn: 'Measures biological harmony, temperamental affinity, and intimacy compatibility.',
    descriptionHi: 'शारीरिक सामंजस्य, स्वभावगत अनुकूलता एवं आत्मीयता का स्तर।',
    classicalRuleReference: 'Brihat Parashara Hora Shastra (Ch. 57, v. 13–17) & Muhurta Chintamani',
    isDoshaPresent: isVaira || yoniPts <= 1,
    doshaName: isVaira ? 'Vaira Yoni (Mortal Enemy)' : undefined
  });

  // 5. Graha Maitri (5 pts)
  const maitriPts = getGrahaMaitriScore(lordA, lordB);
  components.push({
    gunaName: 'Graha Maitri',
    gunaNameHi: 'ग्रह मैत्री',
    maxPoints: 5,
    obtainedPoints: maitriPts,
    partnerAValue: `${signA} (${lordA})`,
    partnerBValue: `${signB} (${lordB})`,
    status: maitriPts >= 4 ? 'EXCELLENT' : maitriPts >= 3 ? 'GOOD' : 'CONCERN',
    descriptionEn: 'Measures psychological resonance, communicative trust, and philosophical outlook.',
    descriptionHi: 'मानसिक तालमेल, वैचारिक सामंजस्य और आपसी संवाद की सहजता।',
    classicalRuleReference: 'Parashari Sambandha Rules',
    isDoshaPresent: false
  });

  // 6. Gana (6 pts)
  const ganaA = GANA_NAMES[nakAIdx];
  const ganaB = GANA_NAMES[nakBIdx];
  let ganaPts = 6;
  if (ganaA === ganaB) ganaPts = 6;
  else if ((ganaA === 'Deva' && ganaB === 'Manushya') || (ganaA === 'Manushya' && ganaB === 'Deva')) ganaPts = 5;
  else if ((ganaA === 'Deva' && ganaB === 'Rakshasa') || (ganaA === 'Rakshasa' && ganaB === 'Deva')) ganaPts = 1;
  else ganaPts = 0;

  const isGanaDosha = ganaPts <= 1;
  components.push({
    gunaName: 'Gana',
    gunaNameHi: 'गण कूट',
    maxPoints: 6,
    obtainedPoints: ganaPts,
    partnerAValue: ganaA,
    partnerBValue: ganaB,
    status: ganaPts >= 5 ? 'EXCELLENT' : ganaPts >= 3 ? 'GOOD' : 'CONCERN',
    descriptionEn: 'Assesses behavioral disposition, temperament, and societal adaptability.',
    descriptionHi: 'स्वभावगत प्रकृति, सामाजिक दृष्टिकोण एवं जीवन शैली का संतुलन।',
    classicalRuleReference: 'Brihat Parashara',
    isDoshaPresent: isGanaDosha,
    doshaName: isGanaDosha ? 'Gana Dosha' : undefined
  });

  // 7. Bhakoot (7 pts)
  const rashiDiff = ((signBIdx - signAIdx + 12) % 12) + 1;
  const isBadBhakoot = [2, 12, 6, 8, 9, 5].includes(rashiDiff);
  let bhakootPts = isBadBhakoot ? 0 : 7;
  let isBhakootCancelled = false;
  let bhakootCancellationReasonEn = '';
  let bhakootCancellationReasonHi = '';

  // Bhakoot cancellation: Same rashi lord or mutual friends
  if (isBadBhakoot) {
    if (lordA === lordB) {
      isBhakootCancelled = true;
      bhakootPts = 7;
      bhakootCancellationReasonEn = 'Both Moon signs share the same governing planetary lord, neutralizing Bhakoot Dosha.';
      bhakootCancellationReasonHi = 'दोनों चंद्र राशियों के स्वामी एक ही ग्रह होने के कारण भकूट दोष पूर्णतया निरस्त हो जाता है।';
    } else if (NATURAL_FRIENDS[lordA]?.includes(lordB) && NATURAL_FRIENDS[lordB]?.includes(lordA)) {
      isBhakootCancelled = true;
      bhakootPts = 7;
      bhakootCancellationReasonEn = 'Mutual friendship between Rashi lords provides auspicious classical cancellation.';
      bhakootCancellationReasonHi = 'राशियों के स्वामियों में परस्पर मित्रता होने से भकूट दोष का शास्त्रीय परिहार होता है।';
    } else if (nakAIdx === nakBIdx) {
      isBhakootCancelled = true;
      bhakootPts = 7;
      bhakootCancellationReasonEn = 'Identical Janma Nakshatra provides classical Bhakoot cancellation.';
      bhakootCancellationReasonHi = 'एक ही जन्म नक्षत्र होने से भकूट दोष का शास्त्रीय परिहार होता है।';
    }
  }

  components.push({
    gunaName: 'Bhakoot',
    gunaNameHi: 'भकूट कूट',
    maxPoints: 7,
    obtainedPoints: bhakootPts,
    partnerAValue: `${signA} (${formatOrdinal(rashiDiff)} from Partner B)`,
    partnerBValue: `${signB}`,
    status: bhakootPts === 7 ? 'EXCELLENT' : 'CONCERN',
    descriptionEn: 'Evaluates financial fortune, family happiness, and life prosperity post-union.',
    descriptionHi: 'वैवाहिक जीवन में वंश वृद्धि, वित्तीय समृद्धि एवं पारिवारिक सुख का आधार।',
    classicalRuleReference: 'Kalasarpa & Bhakoot Parihara Treatises',
    isDoshaPresent: isBadBhakoot && !isBhakootCancelled,
    doshaName: isBadBhakoot ? 'Bhakoot Dosha' : undefined,
    isDoshaCancelled: isBhakootCancelled,
    cancellationReasonEn: bhakootCancellationReasonEn,
    cancellationReasonHi: bhakootCancellationReasonHi
  });

  // 8. Nadi (8 pts)
  const nadiA = NADI_NAMES[nakAIdx];
  const nadiB = NADI_NAMES[nakBIdx];
  let nadiPts = nadiA !== nadiB ? 8 : 0;
  let isNadiCancelled = false;
  let nadiCancellationReasonEn = '';
  let nadiCancellationReasonHi = '';

  if (nadiA === nadiB) {
    // Nadi Cancellation Rules:
    // 1. Same Nakshatra but different Pada (quarter)
    // 2. Different Nakshatras within the same Rashi
    // 3. Same Nakshatra in different Rashis (e.g. Krittika, Mrigashira)
    if (nakAIdx !== nakBIdx && signAIdx === signBIdx) {
      isNadiCancelled = true;
      nadiPts = 8;
      nadiCancellationReasonEn = 'Different Nakshatras residing under the same Moon sign nullify Nadi Dosha.';
      nadiCancellationReasonHi = 'एक ही राशि में भिन्न नक्षत्र होने के कारण नाड़ी दोष का परिहार होता है।';
    } else if (nakAIdx === nakBIdx && (moonA.pada !== moonB.pada)) {
      isNadiCancelled = true;
      nadiPts = 8;
      nadiCancellationReasonEn = 'Difference in Nakshatra Pada (quarters) provides genuine classical mitigation.';
      nadiCancellationReasonHi = 'नक्षत्र के चरण में भिन्नता होने के कारण नाड़ी दोष शांत हो जाता है।';
    } else if (nakAIdx === nakBIdx && signAIdx !== signBIdx) {
      isNadiCancelled = true;
      nadiPts = 8;
      nadiCancellationReasonEn = 'Same Nakshatra divided across different Rashi signs cancels Nadi Dosha.';
      nadiCancellationReasonHi = 'भिन्न राशियों में विभक्त समान नक्षत्र होने से नाड़ी दोष का परिहार होता है।';
    }
  }

  components.push({
    gunaName: 'Nadi',
    gunaNameHi: 'नाड़ी कूट',
    maxPoints: 8,
    obtainedPoints: nadiPts,
    partnerAValue: nadiA,
    partnerBValue: nadiB,
    status: nadiPts === 8 ? 'EXCELLENT' : 'CONCERN',
    descriptionEn: 'Assesses physiological health, genetic compatibility, and lineage vitality.',
    descriptionHi: 'शारीरिक स्वास्थ्य, आनुवंशिक अनुकूलता एवं वंश रक्षा का सर्वप्रमुख आधार।',
    classicalRuleReference: 'Parashari Nadi Parihara Sutras',
    isDoshaPresent: (nadiA === nadiB) && !isNadiCancelled,
    doshaName: (nadiA === nadiB) ? 'Nadi Dosha' : undefined,
    isDoshaCancelled: isNadiCancelled,
    cancellationReasonEn: nadiCancellationReasonEn,
    cancellationReasonHi: nadiCancellationReasonHi
  });

  // Calculate Total Score
  const totalScore = Number(components.reduce((sum, c) => sum + c.obtainedPoints, 0).toFixed(1));
  const compatibilityPercentage = Math.round((totalScore / 36) * 100);

  // Manglik Analysis for both
  const manglikA = calculateDetailedManglik(partnerA, lang);
  const manglikB = calculateDetailedManglik(partnerB, lang);

  let mutualManglikCompatibility: AshtakootaSynastryResult['manglikAnalysis']['mutualManglikCompatibility'] = 'COMPATIBLE';
  let mutualVerdictEn = 'Both charts present harmonious energetic balance.';
  let mutualVerdictHi = 'दोनों कुंडलियों में ऊर्जा का उत्तम संतुलन है।';

  if (manglikA.isManglik && manglikB.isManglik) {
    mutualManglikCompatibility = 'BALANCED';
    mutualVerdictEn = 'Mutual Manglik presence creates ideal classical planetary equilibrium.';
    mutualVerdictHi = 'दोनों कुंडलियों में मांगलिक योग होने से परस्पर दोष निवारण एवं संतुलन स्थापित होता है।';
  } else if ((manglikA.isManglik && !manglikA.isEffectivelyMitigated && !manglikB.isManglik) ||
             (manglikB.isManglik && !manglikB.isEffectivelyMitigated && !manglikA.isManglik)) {
    mutualManglikCompatibility = 'PARTIAL_CONCERN';
    mutualVerdictEn = 'One partner has unmitigated Mars placement; simple remedial harmonization recommended.';
    mutualVerdictHi = 'एक कुंडली में सक्रिय मांगलिक प्रभाव है; सरल उपचारात्मक उपाय लाभकारी रहेंगे।';
  }

  // Verdict Logic
  let verdict: AshtakootaSynastryResult['verdict'] = 'GOOD_WITH_CARE';
  let verdictTitleEn = 'Favorable Match with Strong Foundations';
  let verdictTitleHi = 'सकारात्मक एवं अनुकूल मिलान';

  if (totalScore >= 28) {
    verdict = 'EXCELLENT';
    verdictTitleEn = 'Outstanding Marital Synastry (Uttama Milan)';
    verdictTitleHi = 'उत्तम एवं अत्यंत शुभ मिलान';
  } else if (totalScore >= 21) {
    verdict = 'VERY_GOOD';
    verdictTitleEn = 'Very Good Compatibility (Madhyama-Uttama)';
    verdictTitleHi = 'श्रेष्ठ अनुकूलता एवं सुखद संबंध';
  } else if (totalScore >= 16) {
    verdict = 'AVERAGE_NEEDS_REMEDY';
    verdictTitleEn = 'Moderate Match — Remedial Support Recommended';
    verdictTitleHi = 'मध्यम मिलान — उपचारात्मक संतुलन उपयुक्त';
  } else {
    verdict = 'REQUIRES_CAUTION';
    verdictTitleEn = 'Delicate Synastry — In-Depth Consultation Advised';
    verdictTitleHi = 'विशेष ध्यान देने योग्य — ज्योतिषीय परामर्श अनुशंसित';
  }

  const strengthsEn: string[] = [];
  const strengthsHi: string[] = [];
  const concernsEn: string[] = [];
  const concernsHi: string[] = [];

  components.forEach(c => {
    if (c.status === 'EXCELLENT' || (c.isDoshaCancelled && c.obtainedPoints === c.maxPoints)) {
      strengthsEn.push(`Strong ${c.gunaName} score (${c.obtainedPoints}/${c.maxPoints} pts): ${c.descriptionEn}`);
      strengthsHi.push(`${c.gunaNameHi} में पूर्ण अंक (${c.obtainedPoints}/${c.maxPoints}): ${c.descriptionHi}`);
    } else if (c.isDoshaPresent) {
      concernsEn.push(`${c.gunaName} indicates ${c.doshaName} (${c.obtainedPoints}/${c.maxPoints} pts).`);
      concernsHi.push(`${c.gunaNameHi} में ${c.doshaName} का प्रभाव (${c.obtainedPoints}/${c.maxPoints})।`);
    }
  });

  const constructiveCounselingEn = `Astrology serves as a compass for understanding and cultivating relational harmony. With a synastry score of ${totalScore}/36 (${compatibilityPercentage}%), emotional transparency, mutual respect, and active communication remain the true foundations of enduring partnership.`;
  const constructiveCounselingHi = `ज्योतिष संबंधों में समझ और सामंजस्य बढ़ाने का मार्गदर्शन करता है। ${totalScore}/36 (${compatibilityPercentage}%) के मिलान स्कोर के साथ, परस्पर सम्मान, विश्वास और सकारात्मक संवाद ही सफल जीवन के वास्तविक आधार हैं।`;

  return {
    partnerAName,
    partnerBName,
    partnerAMoonSign: signA,
    partnerBMoonSign: signB,
    partnerANakshatra: NAKSHATRA_NAMES[nakAIdx],
    partnerBNakshatra: NAKSHATRA_NAMES[nakBIdx],
    totalScore,
    maxScore: 36,
    compatibilityPercentage,
    verdict,
    verdictTitleEn,
    verdictTitleHi,
    components,
    manglikAnalysis: {
      partnerA: manglikA,
      partnerB: manglikB,
      mutualManglikCompatibility,
      mutualVerdictEn,
      mutualVerdictHi
    },
    strengthsEn: strengthsEn.length > 0 ? strengthsEn : ['Balanced baseline temperament.'],
    strengthsHi: strengthsHi.length > 0 ? strengthsHi : ['संतुलित आधारभूत स्वभाव।'],
    concernsEn: concernsEn.length > 0 ? concernsEn : ['No major classical doshas identified.'],
    concernsHi: concernsHi.length > 0 ? concernsHi : ['कोई गंभीर शास्त्रीय दोष उपस्थित नहीं है।'],
    constructiveCounselingEn,
    constructiveCounselingHi
  };
}
